import React, { useContext, useEffect, useState } from 'react';
import {
  Box, Button, TextField, Typography, Tabs, Tab, Container,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Dialog, DialogTitle, DialogContent, DialogActions, IconButton,
  Tooltip
} from '@mui/material';
import { AuthContext } from '../..';
import axios from 'axios';
import Swal from 'sweetalert2';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CloseIcon from '@mui/icons-material/Close'

export default function LeadsMasterTypes() {
  const { permissions, token } = useContext(AuthContext);
  const [formdata, setFormdata] = useState({ tab: "1", value: "" });
  const [currentType, setCurrenntType] = useState("Source Type");
  const [activeTab, setActiveTab] = useState(1);

  const [sourceTypeData, setSourceTypeData] = useState([]);
  const [interestLevelData, setInterestLevelData] = useState([]);
  const [leadStageData, setLeadStageData] = useState([]);

  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editValue, setEditValue] = useState('');

  const [editicon, setEditicon] = useState(true);
  const [deleteiocn, setDeleteicon] = useState(true);


  const handleTab = (e, value) => {
    setActiveTab(value);
    if (value === 1) {
      setCurrenntType("Source Type");
      setFormdata(prev => ({ ...prev, tab: "1" }));
    } else if (value === 2) {
      setCurrenntType("Interest Level");
      setFormdata(prev => ({ ...prev, tab: "2" }));
    } else if (value === 3) {
      setCurrenntType("Lead Stage");
      setFormdata(prev => ({ ...prev, tab: "3" }));
    }
  };

  const handler = (e) => {
    const { name, value } = e.target;
    setFormdata({ ...formdata, [name]: value });
  };

  const handleAdd = () => {
    if (!formdata) return;

    axios.post(`${process.env.REACT_APP_API_LINKS}/leadmasters/addleads`, formdata,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true
      }
    )
      .then(res => {
        if (res.status === 200) {
          Swal.fire({ icon: 'success', title: 'Success', text: 'Added successfully', timer: 1500, showConfirmButton: false });
          refreshData();
          setFormdata((prev) =>
          (
            {
              ...prev,
              value: ''
            }
          ))
        }
      })
      .catch(err => {
        Swal.fire({ icon: 'error', title: 'Error', text: 'Already Exists or Failed', timer: 1500, showConfirmButton: false });
      });
  };

  const refreshData = () => {
    axios.get(`${process.env.REACT_APP_API_LINKS}/leadmasters/getleads`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true
    })
      .then(res => {
        setSourceTypeData(res.data.sourceType || []);
        setInterestLevelData(res.data.interestLevels || []);
        setLeadStageData(res.data.leadStages || []);

      })
      .catch(err => {
        console.error('Error fetching data:', err);
      });
  };

  const getCurrentData = () => {
    if (formdata.tab === "1") return sourceTypeData;
    if (formdata.tab === "2") return interestLevelData;
    if (formdata.tab === "3") return leadStageData;
    return [];
  };

  const handleEditClick = (id, value) => {
    setEditId(id);
    setEditValue(value);
    setEditDialogOpen(true);
  };

  const handleUpdate = async () => {
    try {
      const res = await axios.put(`${process.env.REACT_APP_API_LINKS}/leadmasters/updateleads/${editId}`,
        {
          value: editValue,
          tab: formdata.tab,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      );
      if (res.status === 200) {
        Swal.fire({ icon: 'success', title: 'Updated!', timer: 1500, showConfirmButton: false });
        setEditDialogOpen(false);
        refreshData();
      }
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Update failed', timer: 1500, showConfirmButton: false });
    }
  };
  const handleDelete = (id) => {
    axios.delete(`${process.env.REACT_APP_API_LINKS}/leadmasters/deleteleads/${id}/${formdata.tab}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true
      }
    )
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            icon: 'success',
            title: 'Deleted!',
            text: 'Item has been deleted.',
            timer: 1500,
            showConfirmButton: false
          });
          refreshData();
        }
      })
      .catch((error) => {
        console.error('Error deleting item:', error);
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: 'Could not delete the item.',
          timer: 1500,
          showConfirmButton: false
        });
      });
  };


  useEffect(() => {

    refreshData();

  }, []);

  const permissionsaccess = () => {
    const mastersmodule = permissions.masters || {};
    setDeleteicon(mastersmodule.delete === true);
    setEditicon(mastersmodule.update === true);
  };
  useEffect(() => {
    if (permissions && permissions.masters) {
      permissionsaccess();
    }
  }, [permissions]);

  return (
    <Container maxWidth={false} disableGutters sx={{
      px: { xs: 2, sm: 3, md: 4 },
      py: 3,
      backgroundColor: '#ffffff',
      minHeight: 'calc(100vh - 64px)',
      borderRadius: 2,
      boxShadow: { xs: 'none', sm: '0px 0px 5px rgba(187, 222, 241, 0.9)' }
    }}>
      <Box sx={{ fontFamily: 'Open Sans' }}>
        <Tabs
          value={activeTab}
          onChange={handleTab}
          sx={{ mb: 3 }}
          textColor="primary"
          indicatorColor="primary"
          variant="scrollable"
        >
          <Tab label="Source Type" value={1} sx={{ fontSize: { xs: '9px', md: '13px', lg: '14px' } }} />
          <Tab label="Interest Level" value={2} sx={{ fontSize: { xs: '9px', md: '13px', lg: '14px' } }} />
          <Tab label="Lead Stage" value={3} sx={{ fontSize: { xs: '9px', md: '13px', lg: '14px' } }} />
        </Tabs>

        <Typography variant="h6" fontWeight={600} mb={1} sx={{ textAlign: 'center' }}>
          {currentType}
        </Typography>

        {permissions?.masters?.create &&
          <Box display="flex" gap={2} mb={2}>
            <TextField
              name="value"
              size="small"
              fullWidth
              value={formdata.value}
              onChange={handler}
              placeholder={`Add new ${currentType}`}
            />
            <Button variant="contained" sx={{ bgcolor: '#0b85c8' }} onClick={handleAdd}>
              Add
            </Button>
          </Box>
        }

        {getCurrentData().length > 0 && (
          <TableContainer component={Paper}
            sx={{
              mb: 1,
              position: 'relative',
              overflow: 'auto',
              maxHeight: 'calc(100vh - 180px)',
              '&::-webkit-scrollbar': {
                width: '6px',
                height: '6px',
              },
            }}>
            <Table stickyHeader size='small'>
              <TableHead >
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f0f9ff' }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f0f9ff' }}>{currentType}</TableCell>
                  {(editicon || deleteiocn) && <TableCell sx={{ fontWeight: 'bold', bgcolor: '#f0f9ff' }}>Actions</TableCell>}
                </TableRow>
              </TableHead>
              <TableBody>
                {getCurrentData().map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell sx={{ textTransform: 'capitalize' }}>{item.value}</TableCell>

                    {(editicon || deleteiocn) &&
                      <TableCell>
                        {editicon && <Tooltip arrow title="Edit">
                          <IconButton>
                            <EditIcon
                              sx={{ color: "#0b85c8", fontSize: '18px', cursor: 'pointer' }}
                              onClick={() => handleEditClick(item.id, item.value)}
                            />
                          </IconButton>
                        </Tooltip>}
                        {deleteiocn && <Tooltip arrow title="Delete">
                          <IconButton>
                            <DeleteIcon sx={{ color: "red", fontSize: '18px', cursor: 'pointer' }} onClick={() => handleDelete(item.id)} />

                          </IconButton>
                        </Tooltip>}
                      </TableCell>
                    }
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        <Dialog open={editDialogOpen} onClose={() => setEditDialogOpen(false)} fullWidth maxWidth="sm">
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f0f9ff' }}>
            <DialogTitle
              sx={{
                fontFamily: 'Open Sans',
                fontWeight: 600,
                p: 2,
                textAlign: 'center',
                backgroundColor: '#f0f9ff',
                color: '#0b85c8',
                fontSize: { xs: '16px', sm: '18px', md: '20px' },
                margin: 'auto'
              }}
            >
              Edit {currentType}
            </DialogTitle>

            <IconButton onClick={() => setEditDialogOpen(false)} sx={{ color: '#fff' }}>
              <CloseIcon sx={{ backgroundColor: '#0b85c8', fontSize: "24px", borderRadius: 2, mr: 3 }} />
            </IconButton>
          </Box>

          <DialogContent sx={{ bgcolor: '#f0f9ff', mt: -3 }}>
            <Box sx={{ px: 3, pt: 1, bgcolor: '#ffff', borderRadius: 1, boxShadow: 1 }}>
              <TextField
                autoFocus
                fullWidth
                label={`${currentType} Name`}
                value={editValue}
                onChange={(e) => setEditValue(e.target.value)}
                sx={{ mt: 1 }}
              />

              <Box sx={{ textAlign: 'center' }}>
                <Button variant="contained" onClick={handleUpdate} sx={{ bgcolor: '#0b85c8', fontFamily: 'Open Sans', width: 'max-content', margin: 'auto', mb: 2, mt: 2 }}>
                  Update
                </Button>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>

      </Box>
    </Container>
  );
};

